var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer-container" }, [
    _c(
      "div",
      {
        staticClass: "row w-100 no-gutters",
        staticStyle: { margin: "0" },
        attrs: { id: "footer-rights" },
      },
      [
        _c(
          "div",
          { staticClass: "col-12 vertical-center justify-content-center" },
          [
            _vm.showLangSelector
              ? [
                  _c("lang-selector"),
                  _vm._v(" "),
                  _c("span", { staticClass: "mr-2" }, [_vm._v("|")]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("terms-links"),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }